export default __webpack_public_path__ + "static/media/surfdemo_1.377925ff.mp4";